module.exports = __webpack_public_path__ + "static/media/iPhone14-10.d7818a57.png";